import type { FacultyType } from '@/types/composition-functions';
import { useListSchoolFacultiesQuery } from '@/types/vue-apollo-helpers';

export function useFaculties() {
  const { result, loading, error, refetch } = useListSchoolFacultiesQuery(
    { first: 200, page: 1 },
    { fetchPolicy: 'cache-and-network' },
  );

  const faculties = computed<FacultyType[]>(
    () => result.value?.listSchoolFaculties?.data ?? [],
  );

  async function refreshFaculties() {
    await refetch();
  }

  return { faculties, loading, error, refreshFaculties };
}
